module.exports = __webpack_public_path__ + "static/banner-3-dff4163fcd3c321e58fe9771bd675d40.jpg";